<p>issue-seller-contract-brief-report works!</p>
